import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Auditable} from '../@lib/models/commons.models';
import {IForm, IModel} from '../@lib/models/contracts.models';
import { Permission } from './permission.model';
import { UserPermission } from './user-permission.model';

export class UserType extends Auditable implements IModel, IForm {
  id: string;
  created_id: string;
  created_at: Date;
  updated_at: Date;
  created_by: string;
  update_id: string;
  update_by: string;
  active: boolean;
  name: string;
  allPermission = true;
  usertypePermissions: Array<UserPermission> = [];
  profileType: string;

  form: FormGroup;

  constructor(other?: any) {
    super(other);
    if (other) {
      this.id = other.id;
      this.created_at = other.created_at;
      this.updated_at = other.updated_at;
      this.created_id = other.created_id;
      this.created_by = other.created_by;
      this.update_id = other.update_id;
      this.update_by = other.update_by;
      this.active = other.active;
      this.name = other.name;
      this.allPermission = other.allPermission;
      this.profileType = other.profileType;
      this.usertypePermissions = new Array<UserPermission>();
      if (other.usertypePermissions != null && other.usertypePermissions instanceof Array) {
        other.usertypePermissions.forEach((value) => this.usertypePermissions.push(new UserPermission(value)));
      }
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      this.form = new FormGroup({
        id: new FormControl(this.id),
        name: new FormControl(this.name, [Validators.required]),
        allPermission: new FormControl(this.allPermission, [Validators.required]),
        profileType: new FormControl(this.profileType),
      });
    }
    return this.form;
  }

  updateForm(other): void {
    this.form.patchValue(other);
  }
}
